/**
 * @itemgo/service-vehicletransport
 * ItemGo Service Vehicle Transport Plugin
 */

import { vehicleTransportManifest } from "./manifest.js";
import type { PluginModule } from "@itemgo/core";
import { calculateVehicleTransportPricing } from "./services/pricing.js";
import { useVehicleTransportPricing } from "./hooks/useVehicleTransportPricing.js";
import { VehicleTransportPricingBreakdown } from "./components/VehicleTransportPricingBreakdown.js";

export { vehicleTransportManifest };

export const vehicleTransportPlugin: PluginModule = {
  manifest: vehicleTransportManifest,
  services: {
    calculatePrice: calculateVehicleTransportPricing as unknown as (params: unknown) => Promise<unknown>,
  },
  hooks: {
    usePricing: useVehicleTransportPricing as unknown as () => unknown,
  },
  components: {
    PriceCalculator: VehicleTransportPricingBreakdown as unknown as React.ComponentType<unknown>,
  },
};

// Types
export type {
  VehicleTransportPricingConfig,
  VehicleTransportPricingInput,
  VehicleTransportPricingResult,
  VehicleTransportServiceData,
} from "./types.js";

// Schema
export { vehicleTransportSchema, transportVehicleTypes } from "./schema.js";
export type { VehicleTransportFormData } from "./schema.js";

// Services
export {
  calculateVehicleTransportPricing,
  formatPence,
  DEFAULT_VEHICLETRANSPORT_PRICING_CONFIG,
} from "./services/pricing.js";

// React Hooks
export { useVehicleTransportPricing } from "./hooks/useVehicleTransportPricing.js";

// React Components
export { VehicleTransportPricingBreakdown } from "./components/VehicleTransportPricingBreakdown.js";
